import React from 'react';
import { Demographics, ILocalDemographic } from 'utils/entities';
import { DemographicCharts } from '../components/DemographicCharts';

interface SocialRankingSectionProps {
  demographic: { [rating in Demographics]: ILocalDemographic | number };
  areaCityName?: string;
  areaNeighbourhoodName?: string;
}

export const SocialRankingSection: React.FC<SocialRankingSectionProps> = ({ demographic, areaCityName = null, areaNeighbourhoodName = null }) => {
  if (!demographic) return null;
  return (
    <DemographicCharts demographic={demographic} areaName={areaCityName || areaNeighbourhoodName} />
  );
};
